export default "__VITE_ASSET__CRDbLXWv__"